module.exports = __webpack_public_path__ + "assets/certificate_pdf/20220812175756Certificate.aa847c6b.pdf";